import { render, staticRenderFns } from "./page-result-view.vue?vue&type=template&id=1fadcf92&scoped=true&"
import script from "./page-result-view.vue?vue&type=script&lang=js&"
export * from "./page-result-view.vue?vue&type=script&lang=js&"
import style0 from "./page-result-view.vue?vue&type=style&index=0&id=1fadcf92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fadcf92",
  null
  
)

component.options.__file = "page-result-view.vue"
export default component.exports